import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import 'moment-timezone';
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// -
import DateTimesUtils from "core/utils/DateTimesUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axiApi from "ApiCaller";
import MapRouteCalculatorManager from "../route-static/MapRouteCalculatorManager";
import Loader from "components/loaders/Loader";
import {REQUIRES_FIELDS} from "site-apps/distribution/route/RouteRequires";

const scheduleModel = {
    event: {
        id: "",
        calendarId: "",
        title: "",
        category: "time",
        start: "",
        end: "",
        color: "",
        backgroundColor: "",
        raw: "",
        progId: 0,
        routeId: 0,
        type: "s"
    },
    prog: {
        id: 7,
        name: "",
        description: "",
        type: "o",
        is_periodic: false,
        every: 0,
        repeat: "",
        date_start: "",
        date_end: null,
        compile: "",
        run: "",
        values: {},
        routes: []
    },
    route: {
        id: 0,
        item: {
            id: 0,
            name: "",
            waste_type: "",
            download_type: ""
        },
        name: "",
        type: ""
    }
}
const iconsTypes = {
    "s": "fa-location-dot",
    "d": "fa-route",
    "f": "fa-sack-xmark"
}

const ModalEvent = ({ show, setShow, schedule }) => {
    const { t: tF } = useTranslation("routes");
    const { t: _Tt } = useTranslation("tables");
    const [item, setItem] = useState({ ...scheduleModel });
    const [routeData, setRouteData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (schedule && schedule.prog && schedule.route) {
            setItem({ ...schedule });
            fetchRouteData(schedule);
        }
    }, [schedule]);

    const fetchRouteData = (sh) => {
        if (sh.route.type !== "s") return;
        setLoading(true);
        const date = moment(sh.event.start).format("YYYY-MM-DD");
        axiApi.post("/api/distribution/route/", {
            type: "virtual",
            programming: sh.prog.id,
            route: sh.route.item.id,
            created: date
        }).then(resp => {
            if (resp.data.status) {
                setRouteData(resp.data.item);
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleClose = () => {
        setShow(false);
    }
    const styleLabel = { maxWidth: "100px" }

    return (
        <Modal show={show} animation={true} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon={iconsTypes[item.event.type]} />
                </div>
                <div className="preview-title d-inline-flex align-items-center">
                    <Modal.Title className="d-inline-flex ms-1">
                        <div>
                            <div className="h4 ms-0">
                                {item.route.name}
                            </div>
                        </div>
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body style={{ minHeight: "400px", position: "relative" }}>
                <Loader show={loading} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5">
                            <h4 className="mb-0">{_Tt("common.timetable")}</h4>
                            <hr className="mt-1" />
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.name")}:</label></div>
                                <div className="col mb-1"><strong>{item.prog.name}</strong></div>
                            </div>
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.description")}:</label></div>
                                <div className="col mb-1"><strong>{item.prog.description}</strong></div>
                            </div>
                            {item.prog.date_start ? (
                                <div className="row">
                                    <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.from")}:</label></div>
                                    <div className="col mb-1"><strong>{moment(item.prog.date_start).format("DD-MM-YYYY")}</strong></div>
                                    {item.prog.date_end && (
                                        <>
                                            <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.to")}:</label></div>
                                            <div className="col mb-1"><strong>{moment(item.prog.date_end).format("DD-MM-YYYY")}</strong></div>
                                        </>
                                    )}
                                </div>
                            ) : ""}
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.calculate")}:</label></div>
                                <div className="col mb-1"><strong>{DateTimesUtils.timeToHourMinute(item.prog.compile)}</strong></div>
                            </div>

                            <h4 className="mb-0 mt-4">{_Tt("common.route")}</h4>
                            <hr className="mt-1" />
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.name")}:</label></div>
                                <div className="col mb-1"><strong>{item.route.name}</strong></div>
                            </div>
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("common.type")}:</label></div>
                                <div className="col mb-1"><strong>{item.route.type === "s" ? _Tt("common.static") : item.route.type === "f" ? _Tt("common.flytipping") : _Tt("common.dynamic")}</strong></div>
                            </div>
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("programming.starts")}:</label></div>
                                <div className="col mb-1"><strong>{DateTimesUtils.timeToHourMinute(item.prog.run)}</strong></div>
                            </div>
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("users.driver")}:</label></div>
                                <div className="col mb-1"><strong>{item.route.driver || "—"}</strong></div>
                            </div>
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("fleet.truck")}:</label></div>
                                <div className="col mb-1"><strong>{item.route.truck || "—"}</strong></div>
                            </div>
                            <div className="row">
                                <div className="col mb-1 text-end" style={styleLabel}><label className="text-muted">{_Tt("fleet.requires")}:</label></div>
                                <div className="col mb-1">
                                    <div className="d-flex flex-wrap gap-2">
                                        {REQUIRES_FIELDS.map(({key, label}) => (
                                            <div
                                                key={key}
                                                className="d-flex align-items-center gap-1"
                                                title={label}>
                                                <small className="text-muted">{label}</small>
                                                <Form.Check
                                                    type="switch"
                                                    checked={!!(item.route.requires || {})[key]}
                                                    disabled
                                                    readOnly
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7">
                            {routeData && (
                                <div style={{ height: "400px", border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden" }}>
                                    <MapRouteCalculatorManager
                                        waypoints={routeData.checkpoints || []}
                                        setWaypoints={() => { }}
                                        center={routeData.checkpoints && routeData.checkpoints[0] ? [routeData.checkpoints[0].lat, routeData.checkpoints[0].lng] : [40, -3]}
                                        hasChanged={false}
                                        setHasChanged={() => { }}
                                        geojson={routeData.geojson}
                                        setGeojson={() => { }}
                                        duration={routeData.duration}
                                        setDuration={() => { }}
                                        tF={tF}
                                        readOnly={true}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalEvent;
